export default "__VITE_ASSET__VwBB4j99__"